module.exports = __webpack_public_path__ + "static/Cover-23a22ca444988a31c1b7aa1530ffd616.png";